
import { Injectable } from '@angular/core';

@Injectable()

export class ViewerControlInfoService  {
    constructor() {}
    getViewerProperties()
    {
        
        const viewerProperties: Array<any>[]=
        [
        [ 
            { key: 'viewerList', label: 'Viewer List', iterable: true, modal: false, required: false,
            items : [{ key: 'RTN', type: 'text' },
            { key: 'Form Name', type: 'text' },
            { key: 'Submit Date',   type: 'text' },
            { key: 'Attachments',   type: 'text' },
            { key: 'Notes',   type: 'text' },
            { key: 'ID',   type: 'text' }]
            }
        ]
        ]
        return viewerProperties;
    }

    // getScannedProperties()
    // {
        
    //     const scannedProperties: Array<any>[]=
    //     [
    //     [ 
    //         { key: 'scannedList', label: 'Scanned List', iterable: true, modal: false, required: false,
    //         items : [{ key: 'RTN', type: 'text' },
    //         { key: 'Document Type', type: 'text' },
    //         { key: 'Submit Date',   type: 'text' },
    //         { key: 'Pages',   type: 'text' },
    //         { key: 'File Name',   type: 'text' }]
    //         }
    //     ]
    //     ]
    //     return scannedProperties;
    // }
}
